import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {
  }

  storeRefreshToken(refreshToken: string): void {
    localStorage.setItem('refreshToken', refreshToken);
  }

  removeRefreshToken(): void {
    localStorage.removeItem('refreshToken');
  }

  loadRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  storeEmail(email: string): void {
    localStorage.setItem('email', email);
  }

  removeEmail(): void {
    localStorage.removeItem('email');
  }

  loadEmail(): string | null {
    return localStorage.getItem('email');
  }

  storeCustomerId(customerId: number): void {
    localStorage.setItem('customerId', customerId.toString());
  }

  loadCustomerId(): number | null {
    let customerIdString = localStorage.getItem('customerId');
    let customerId = Number(customerIdString);
    return Number.isNaN(customerId) ? null : customerId;
  }
}
